import React, { useState, useEffect, useContext, useCallback, useRef, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import './style.css'
import '../../styles/page-titles.css'
import { Modal, Tab, Tabs } from "react-bootstrap";
import { IoCubeOutline } from "react-icons/io5";
import styled from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getStoredUser } from '../../utils/safeStorage';

import { SidebarContext } from "../../AppRoutes";
import {
    getCategorias,
    getItens,

    updateEstoqueItem,
    getMateriasPrimas,
    createMateriaPrima,
    updateMateriaPrima,
    deleteMateriaPrima,
    getConfiguracoesEstoque,
    updateConfiguracoesEstoque,

    // Receitas
    updateItemComposicao,
    getItemComposicao,
    updateAdicionalComposicao,
    getAdicionaisComReceita,

    // Movimentações
    getMovimentacoesEstoque,
    registrarEntradaEstoque,
    registrarAjusteEstoque,
    registrarEntradaItem,
    registrarAjusteItem,
    registrarSaidaEstoque,
    registrarSaidaItem,

    // Alertas
    getAlertasEstoque
} from "../../services/api";




import ConfirmDialog from "../../components/ConfirmDialog";

import { toast } from "react-toastify";
import Loading from "react-loading";
// Ícones
import { FaEdit, FaTrash, FaPlus, FaMinus, FaBoxOpen, FaWarehouse, FaCog, FaSearch, FaCheck, FaTimes, FaExchangeAlt } from "react-icons/fa";
import { MdFilterList, MdReceipt } from "react-icons/md";
import { IoNutrition } from "react-icons/io5";
import { formatPriceWithSymbol, getCurrencySymbol } from "../../utils/currency";
import getApiUrl from "../../utils/getApiUrl";
import io from 'socket.io-client';

const PageContainer = styled.div`
    display: flex;
    margin-left: ${({ $sidebar }) => ($sidebar ? '250px' : '100px')};
    min-height: 100vh;
    transition: margin-left 200ms ease;
    background: #ffffff;

    @media (max-width: 880px) {
        margin-left: 0;
    }
`;

const ContentWrapper = styled.div`
    width: 100%;
    padding: 24px;

    @media (max-width: 768px) {
        padding: 16px;
    }
`;

function GestaoEstoque() {
    const { sidebar } = useContext(SidebarContext);
    const location = useLocation();
    const { t } = useTranslation('estoque');

    const userParse = getStoredUser();
    const userID = userParse?._id;
    const empresa = localStorage.getItem('empresa')
    const empresaParse = JSON.parse(empresa)
    const empresaObjId = empresaParse._id;
    const idEmpresa = empresaParse.id_empresa
    const vinculo_empresa = empresaParse.cnpj




    // Detectar aba ativa pela URL
    const urlParams = new URLSearchParams(location.search);
    const tabFromUrl = urlParams.get('tab');

    // Estados principais
    const [categorias, setCategorias] = useState([]);
    const [itens, setItens] = useState([]);
    const [materiasPrimas, setMateriasPrimas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(tabFromUrl === 'configuracoes' ? 'configuracoes' : 'itens');

    // Atualizar aba quando URL mudar
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const tabFromUrl = urlParams.get('tab');
        if (tabFromUrl === 'configuracoes') {
            setActiveTab('configuracoes');
        }
    }, [location.search]);

    // Estados para modais
    const [showModalMateriaPrima, setShowModalMateriaPrima] = useState(false);
    const [editingMateriaPrima, setEditingMateriaPrima] = useState(null);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    // Estados para inputs inline



    // Estados para configurações de estoque
    const [configuracoesEstoque, setConfiguracoesEstoque] = useState({
        habilitado: false,
        darBaixaAutomatica: true,
        esgotarItemAutomaticamente: true,
        decrementarMateriaPrima: true,
        bloquearPedidoSemEstoque: false,
        alertaEstoqueBaixo: true
    });

    // Estados para receitas
    const [adicionaisGrupos, setAdicionaisGrupos] = useState([]);
    const [showRecipeModal, setShowRecipeModal] = useState(false);
    const [recipeTarget, setRecipeTarget] = useState(null); // { type: 'item'|'adicional', id, grupoId?, name, composicao }
    const [recipeIngredients, setRecipeIngredients] = useState([]); // [{ materiaPrimaId, quantidadeUtilizada, _mpData }]
    const [savingRecipe, setSavingRecipe] = useState(false);
    const [searchReceitas, setSearchReceitas] = useState("");

    // Estados para movimentações
    const [movimentacoes, setMovimentacoes] = useState([]);
    const [movimentacoesPagination, setMovimentacoesPagination] = useState({ page: 1, per_page: 15, total: 0, totalPages: 0 });
    const [movimentacoesLoading, setMovimentacoesLoading] = useState(false);
    const [filtroTipoMov, setFiltroTipoMov] = useState("");
    const [filtroMPMov, setFiltroMPMov] = useState("");
    const [filtroDateStart, setFiltroDateStart] = useState("");
    const [filtroDateEnd, setFiltroDateEnd] = useState("");
    const [showEntryModal, setShowEntryModal] = useState(false);
    const [showAdjustmentModal, setShowAdjustmentModal] = useState(false);
    const [showExitModal, setShowExitModal] = useState(false);
    const [entryForm, setEntryForm] = useState({ materiaPrimaId: '', quantidade: '', motivo: '' });
    const [adjustmentForm, setAdjustmentForm] = useState({ materiaPrimaId: '', novaQuantidade: '', motivo: '' });
    const [exitForm, setExitForm] = useState({ materiaPrimaId: '', quantidade: '', motivo: '' });

    // Sub-aba dentro de movimentações
    const [movSubTab, setMovSubTab] = useState('itens');

    // Estados para movimentações de ITENS (sub-aba)
    const [movItens, setMovItens] = useState([]);
    const [movItensPagination, setMovItensPagination] = useState({ page: 1, per_page: 15, total: 0, totalPages: 0 });
    const [movItensLoading, setMovItensLoading] = useState(false);
    const [filtroTipoMovItem, setFiltroTipoMovItem] = useState("");
    const [filtroItemMov, setFiltroItemMov] = useState("");
    const [filtroDateStartItem, setFiltroDateStartItem] = useState("");
    const [filtroDateEndItem, setFiltroDateEndItem] = useState("");
    const [showItemEntryModal, setShowItemEntryModal] = useState(false);
    const [showItemAdjustmentModal, setShowItemAdjustmentModal] = useState(false);
    const [showItemExitModal, setShowItemExitModal] = useState(false);
    const [itemEntryForm, setItemEntryForm] = useState({ itemId: '', quantidade: '', motivo: '' });
    const [itemAdjustmentForm, setItemAdjustmentForm] = useState({ itemId: '', novaQuantidade: '', motivo: '' });
    const [itemExitForm, setItemExitForm] = useState({ itemId: '', quantidade: '', motivo: '' });

    // Estados para movimentações de ADICIONAIS (sub-aba)
    const [movAdicionais, setMovAdicionais] = useState([]);
    const [movAdicionaisPagination, setMovAdicionaisPagination] = useState({ page: 1, per_page: 15, total: 0, totalPages: 0 });
    const [movAdicionaisLoading, setMovAdicionaisLoading] = useState(false);
    const [filtroTipoMovAdic, setFiltroTipoMovAdic] = useState("");
    const [filtroDateStartAdic, setFiltroDateStartAdic] = useState("");
    const [filtroDateEndAdic, setFiltroDateEndAdic] = useState("");

    // Sub-aba dentro de receitas
    const [receitasSubTab, setReceitasSubTab] = useState('itens');

    // Estados para busca
    const [searchItens, setSearchItens] = useState("");
    const [searchMaterias, setSearchMaterias] = useState("");

    // Estados para filtros de matérias-primas
    const [filtroStatus, setFiltroStatus] = useState("todos"); // todos, disponivel, estoque_baixo, sem_estoque
    const [filtroUnidade, setFiltroUnidade] = useState("todas"); // todas, un, kg, g, l, ml

    // Estados para controle de quantidade
    const [quantidadeTemp, setQuantidadeTemp] = useState({});
    const [showConfirmQuantidade, setShowConfirmQuantidade] = useState({});

    // Estados para edição inline de matérias-primas
    const [editingQuantidadeMateria, setEditingQuantidadeMateria] = useState(null);
    const [quantidadeTempMateria, setQuantidadeTempMateria] = useState({});

    // Form para matéria-prima
    const [formMateriaPrima, setFormMateriaPrima] = useState({
        nome: '',
        unidadeMedida: 'un',
        quantidade: 0,
        custoPorUnidade: '',
        limiteMinimo: 0
    });

    const loadData = useCallback(async () => {
        try {
            setLoading(true);

            // Carregar categorias e itens
            const categoriasResponse = await getCategorias();
            const itensResponse = await getItens();

            // Corrigir a estrutura da resposta da API
            const categoriasArray = categoriasResponse.data?.categorias || [];
            const itensArray = itensResponse.data?.itens || [];

            setCategorias(categoriasArray);
            setItens(itensArray);

            // Carregar matérias-primas
            try {
                const materiasResponse = await getMateriasPrimas();
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("materiasResponse: ", materiasResponse);
                setMateriasPrimas(materiasResponse.data?.materiasPrimas || []);
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao carregar matérias-primas:", error);
                setMateriasPrimas([]);
            }

            // Carregar adicionais (para aba de receitas)
            try {
                const adicionaisResponse = await getAdicionaisComReceita();
                setAdicionaisGrupos(adicionaisResponse.data?.grupos || []);
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao carregar adicionais:", error);
                setAdicionaisGrupos([]);
            }

            // Carregar configurações de estoque
            try {
                const configResponse = await getConfiguracoesEstoque();
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("[DEBUG] Configurações carregadas do servidor:", configResponse.data);
                const configs = configResponse.data?.configuracoes || {
                    habilitado: false,
                    darBaixaAutomatica: true,
                    esgotarItemAutomaticamente: true
                };
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("[DEBUG] Configurações finais aplicadas:", configs);
                setConfiguracoesEstoque(configs);
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Erro ao carregar configurações de estoque:", error);
            }

        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao carregar dados:", error);
            toast.error(t('toasts.loadError'));
        } finally {
            setLoading(false);
        }
    }, [userID, idEmpresa, vinculo_empresa, empresaObjId, t]);

    useEffect(() => {
        if (userID) {
            loadData();
        }
    }, [loadData, userID]);

    // ============================================================
    // SOCKET.IO - Alertas de estoque baixo em tempo real
    // ============================================================
    const socketRef = useRef(null);

    useEffect(() => {
        if (!idEmpresa) return;

        const API_URL = getApiUrl();
        const socket = io(API_URL, {
            withCredentials: true,
            transports: ['websocket'],
            auth: { token: localStorage.getItem('token') },
            reconnection: true,
            reconnectionAttempts: 3,
            reconnectionDelay: 3000,
        });
        socketRef.current = socket;

        socket.on('connect', () => {
            socket.emit('joinCompanyRoom', {
                companyId: idEmpresa.toString(),
                clientId: `estoque_${Date.now()}`
            });
        });

        socket.on('estoque_baixo_alerta', (data) => {
            if (data?.alertas) {
                data.alertas.forEach(alerta => {
                    if (alerta.tipo === 'sem_estoque') {
                        toast.error(t('alerts.outOfStock', { name: alerta.nome }), { autoClose: 8000 });
                    } else {
                        toast.warning(t('alerts.lowStock', {
                            name: alerta.nome,
                            qty: alerta.quantidade,
                            unit: alerta.unidadeMedida
                        }), { autoClose: 8000 });
                    }
                });
                // Recarregar dados para refletir as mudanças
                loadData();
            }
        });

        return () => {
            socket.off('estoque_baixo_alerta');
            socket.disconnect();
            socketRef.current = null;
        };
    }, [idEmpresa, t, loadData]);

    // ============================================================
    // RECEITAS - Handlers
    // ============================================================

    const openRecipeModal = async (type, id, grupoId, name, composicaoAtual) => {
        setRecipeTarget({ type, id, grupoId, name });
        // Mapear composição existente com dados da MP
        const ingredients = (composicaoAtual || []).map(c => {
            const mp = materiasPrimas.find(m => m._id === (c.materiaPrimaId?._id || c.materiaPrimaId));
            return {
                materiaPrimaId: c.materiaPrimaId?._id || c.materiaPrimaId,
                quantidadeUtilizada: c.quantidadeUtilizada,
                _mpData: mp || null
            };
        });
        setRecipeIngredients(ingredients);
        setShowRecipeModal(true);
    };

    const addRecipeIngredient = () => {
        setRecipeIngredients(prev => [...prev, { materiaPrimaId: '', quantidadeUtilizada: '', _mpData: null }]);
    };

    const updateRecipeIngredient = (index, field, value) => {
        setRecipeIngredients(prev => {
            const updated = [...prev];
            if (field === 'materiaPrimaId') {
                const mp = materiasPrimas.find(m => m._id === value);
                updated[index] = { ...updated[index], materiaPrimaId: value, _mpData: mp || null };
            } else {
                updated[index] = { ...updated[index], [field]: value };
            }
            return updated;
        });
    };

    const removeRecipeIngredient = (index) => {
        setRecipeIngredients(prev => prev.filter((_, i) => i !== index));
    };

    const saveRecipe = async () => {
        if (!recipeTarget) return;
        setSavingRecipe(true);
        try {
            const composicao = recipeIngredients
                .filter(i => i.materiaPrimaId && i.quantidadeUtilizada > 0)
                .map(i => ({ materiaPrimaId: i.materiaPrimaId, quantidadeUtilizada: parseFloat(i.quantidadeUtilizada) }));

            if (recipeTarget.type === 'item') {
                await updateItemComposicao(recipeTarget.id, composicao);
            } else {
                await updateAdicionalComposicao(recipeTarget.grupoId, recipeTarget.id, composicao);
            }

            toast.success(t('recipes.savedSuccess'));
            setShowRecipeModal(false);
            loadData(); // Recarregar dados
        } catch (error) {
            console.error("Erro ao salvar receita:", error);
            toast.error(t('recipes.saveError'));
        } finally {
            setSavingRecipe(false);
        }
    };

    const getRecipeCost = () => {
        return recipeIngredients.reduce((total, ing) => {
            if (ing._mpData?.custoPorUnidade && ing.quantidadeUtilizada) {
                return total + (ing._mpData.custoPorUnidade * parseFloat(ing.quantidadeUtilizada));
            }
            return total;
        }, 0);
    };

    // ============================================================
    // MOVIMENTAÇÕES - Handlers
    // ============================================================

    // Carregar movimentações de MATÉRIAS-PRIMAS
    const loadMovimentacoes = useCallback(async (page = 1) => {
        setMovimentacoesLoading(true);
        try {
            const params = { page, per_page: 15, origem: 'materia_prima' }; // Inclui MP + adicionais (tudo que não é 'item')
            if (filtroTipoMov) params.tipo = filtroTipoMov;
            if (filtroMPMov) params.materiaPrimaId = filtroMPMov;
            if (filtroDateStart) params.startDate = filtroDateStart;
            if (filtroDateEnd) params.endDate = filtroDateEnd;

            const response = await getMovimentacoesEstoque(params);
            setMovimentacoes(response.data?.movimentacoes || []);
            setMovimentacoesPagination(response.data?.pagination || { page: 1, per_page: 15, total: 0, totalPages: 0 });
        } catch (error) {
            console.error("Erro ao carregar movimentações MP:", error);
            toast.error(t('movements.loadError'));
        } finally {
            setMovimentacoesLoading(false);
        }
    }, [filtroTipoMov, filtroMPMov, filtroDateStart, filtroDateEnd, t]);

    // Carregar movimentações de ITENS
    const loadMovimentacoesItens = useCallback(async (page = 1) => {
        setMovItensLoading(true);
        try {
            const params = { page, per_page: 15, origem: 'item' };
            if (filtroTipoMovItem) params.tipo = filtroTipoMovItem;
            if (filtroItemMov) params.itemId = filtroItemMov;
            if (filtroDateStartItem) params.startDate = filtroDateStartItem;
            if (filtroDateEndItem) params.endDate = filtroDateEndItem;

            const response = await getMovimentacoesEstoque(params);
            setMovItens(response.data?.movimentacoes || []);
            setMovItensPagination(response.data?.pagination || { page: 1, per_page: 15, total: 0, totalPages: 0 });
        } catch (error) {
            console.error("Erro ao carregar movimentações itens:", error);
            toast.error(t('movements.loadError'));
        } finally {
            setMovItensLoading(false);
        }
    }, [filtroTipoMovItem, filtroItemMov, filtroDateStartItem, filtroDateEndItem, t]);

    // Carregar movimentações de ADICIONAIS
    const loadMovimentacoesAdicionais = useCallback(async (page = 1) => {
        setMovAdicionaisLoading(true);
        try {
            const params = { page, per_page: 15, origem: 'adicional' };
            if (filtroTipoMovAdic) params.tipo = filtroTipoMovAdic;
            if (filtroDateStartAdic) params.startDate = filtroDateStartAdic;
            if (filtroDateEndAdic) params.endDate = filtroDateEndAdic;

            const response = await getMovimentacoesEstoque(params);
            setMovAdicionais(response.data?.movimentacoes || []);
            setMovAdicionaisPagination(response.data?.pagination || { page: 1, per_page: 15, total: 0, totalPages: 0 });
        } catch (error) {
            console.error("Erro ao carregar movimentações adicionais:", error);
            toast.error(t('movements.loadError'));
        } finally {
            setMovAdicionaisLoading(false);
        }
    }, [filtroTipoMovAdic, filtroDateStartAdic, filtroDateEndAdic, t]);

    // Carregar movimentações quando a aba/sub-aba for selecionada
    useEffect(() => {
        if (activeTab === 'movimentacoes') {
            if (movSubTab === 'itens') loadMovimentacoesItens();
            else loadMovimentacoes();
        }
    }, [activeTab, movSubTab, loadMovimentacoes, loadMovimentacoesItens]);

    const handleSaveEntry = async () => {
        if (!entryForm.materiaPrimaId || !entryForm.quantidade || parseFloat(entryForm.quantidade) <= 0) {
            toast.error(t('movements.entryError'));
            return;
        }
        try {
            await registrarEntradaEstoque(entryForm.materiaPrimaId, {
                quantidade: parseFloat(entryForm.quantidade),
                motivo: entryForm.motivo
            });
            toast.success(t('movements.entrySuccess'));
            setShowEntryModal(false);
            setEntryForm({ materiaPrimaId: '', quantidade: '', motivo: '' });
            loadMovimentacoes();
            loadData(); // Atualizar quantidades
        } catch (error) {
            console.error("Erro ao registrar entrada:", error);
            toast.error(t('movements.entryError'));
        }
    };

    const handleSaveAdjustment = async () => {
        if (!adjustmentForm.materiaPrimaId || adjustmentForm.novaQuantidade === '' || !adjustmentForm.motivo?.trim()) {
            toast.error(t('movements.adjustmentError'));
            return;
        }
        try {
            await registrarAjusteEstoque(adjustmentForm.materiaPrimaId, {
                novaQuantidade: parseFloat(adjustmentForm.novaQuantidade),
                motivo: adjustmentForm.motivo
            });
            toast.success(t('movements.adjustmentSuccess'));
            setShowAdjustmentModal(false);
            setAdjustmentForm({ materiaPrimaId: '', novaQuantidade: '', motivo: '' });
            loadMovimentacoes();
            loadData(); // Atualizar quantidades
        } catch (error) {
            console.error("Erro ao registrar ajuste:", error);
            toast.error(t('movements.adjustmentError'));
        }
    };

    // Handlers para movimentações de ITENS
    const handleSaveItemEntry = async () => {
        if (!itemEntryForm.itemId || !itemEntryForm.quantidade || parseFloat(itemEntryForm.quantidade) <= 0) {
            toast.error(t('movements.entryError'));
            return;
        }
        try {
            await registrarEntradaItem(itemEntryForm.itemId, {
                quantidade: parseFloat(itemEntryForm.quantidade),
                motivo: itemEntryForm.motivo
            });
            toast.success(t('movements.entrySuccess'));
            setShowItemEntryModal(false);
            setItemEntryForm({ itemId: '', quantidade: '', motivo: '' });
            loadMovimentacoesItens();
            loadData();
        } catch (error) {
            console.error("Erro ao registrar entrada de item:", error);
            toast.error(t('movements.entryError'));
        }
    };

    const handleSaveItemAdjustment = async () => {
        if (!itemAdjustmentForm.itemId || itemAdjustmentForm.novaQuantidade === '' || !itemAdjustmentForm.motivo?.trim()) {
            toast.error(t('movements.adjustmentError'));
            return;
        }
        try {
            await registrarAjusteItem(itemAdjustmentForm.itemId, {
                novaQuantidade: parseFloat(itemAdjustmentForm.novaQuantidade),
                motivo: itemAdjustmentForm.motivo
            });
            toast.success(t('movements.adjustmentSuccess'));
            setShowItemAdjustmentModal(false);
            setItemAdjustmentForm({ itemId: '', novaQuantidade: '', motivo: '' });
            loadMovimentacoesItens();
            loadData();
        } catch (error) {
            console.error("Erro ao registrar ajuste de item:", error);
            toast.error(t('movements.adjustmentError'));
        }
    };

    // Handlers para SAÍDA manual de MP
    const handleSaveExit = async () => {
        if (!exitForm.materiaPrimaId || !exitForm.quantidade || parseFloat(exitForm.quantidade) <= 0 || !exitForm.motivo?.trim()) {
            toast.error(t('movements.exitError'));
            return;
        }
        try {
            await registrarSaidaEstoque(exitForm.materiaPrimaId, {
                quantidade: parseFloat(exitForm.quantidade),
                motivo: exitForm.motivo
            });
            toast.success(t('movements.exitSuccess'));
            setShowExitModal(false);
            setExitForm({ materiaPrimaId: '', quantidade: '', motivo: '' });
            loadMovimentacoes();
            loadData();
        } catch (error) {
            console.error("Erro ao registrar saída:", error);
            toast.error(t('movements.exitError'));
        }
    };

    // Handlers para SAÍDA manual de Item
    const handleSaveItemExit = async () => {
        if (!itemExitForm.itemId || !itemExitForm.quantidade || parseFloat(itemExitForm.quantidade) <= 0 || !itemExitForm.motivo?.trim()) {
            toast.error(t('movements.exitError'));
            return;
        }
        try {
            await registrarSaidaItem(itemExitForm.itemId, {
                quantidade: parseFloat(itemExitForm.quantidade),
                motivo: itemExitForm.motivo
            });
            toast.success(t('movements.exitSuccess'));
            setShowItemExitModal(false);
            setItemExitForm({ itemId: '', quantidade: '', motivo: '' });
            loadMovimentacoesItens();
            loadData();
        } catch (error) {
            console.error("Erro ao registrar saída de item:", error);
            toast.error(t('movements.exitError'));
        }
    };

    const getMovementTypeColor = (tipo) => {
        switch (tipo) {
            case 'entrada': return '#28a745';
            case 'saida': case 'saida_automatica': return '#dc3545';
            case 'ajuste': return '#ffc107';
            default: return '#6c757d';
        }
    };

    // Função para toggle do controle de estoque de um item
    const toggleControleEstoque = async (itemId, currentValue) => {
        try {
            // Verificar se o módulo de estoque está habilitado
            if (!currentValue && !configuracoesEstoque.habilitado) {
                toast.error(t('toasts.moduleNotEnabled'));
                return;
            }

            // Preparar dados para atualização
            const updateData = { controlarEstoque: !currentValue };

            // Se estiver ativando o controle de estoque
            if (!currentValue) {
                // Inicializar com quantidade 0
                updateData.quantidadeEstoque = 0;

                // Só marcar como esgotado se a configuração de esgotamento automático estiver habilitada
                if (configuracoesEstoque.esgotarItemAutomaticamente) {
                    updateData.out = true;
                    updateData.out_salao = true;
                } else {
                    // Se esgotamento automático estiver desabilitado, manter item disponível
                    updateData.out = false;
                    updateData.out_salao = false;
                }
            }

            await updateEstoqueItem(itemId, updateData);

            // Atualizar estado local
            setItens(prevItens =>
                prevItens.map(item =>
                    item._id === itemId
                        ? { ...item, ...updateData }
                        : item
                )
            );

            if (!currentValue) {
                if (configuracoesEstoque.esgotarItemAutomaticamente) {
                    toast.success(t('toasts.stockEnabledExhausted'));
                } else {
                    toast.success(t('toasts.stockEnabled'));
                }
            } else {
                toast.success(t('toasts.stockDisabled'));
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao atualizar controle de estoque:", error);
            toast.error(t('toasts.stockControlError'));
        }
    };

    // Função para atualizar quantidade em estoque
    const updateQuantidadeEstoque = async (itemId, novaQuantidade) => {
        try {
            const updateData = { quantidadeEstoque: novaQuantidade };

            // Se a quantidade for 0 e o esgotamento automático estiver habilitado, esgotar o item
            if (novaQuantidade === 0 && configuracoesEstoque.esgotarItemAutomaticamente) {
                updateData.out = true;
                updateData.out_salao = true;
            } else if (novaQuantidade > 0) {
                // Se a quantidade for maior que 0, garantir que o item não esteja esgotado
                updateData.out = false;
                updateData.out_salao = false;
            }

            await updateEstoqueItem(itemId, updateData);

            // Atualizar estado local
            setItens(prevItens =>
                prevItens.map(item =>
                    item._id === itemId
                        ? { ...item, ...updateData }
                        : item
                )
            );

            toast.success(t('toasts.quantityUpdated'));

            if (novaQuantidade === 0 && configuracoesEstoque.esgotarItemAutomaticamente) {
                toast.info(t('toasts.autoExhausted'));
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao atualizar quantidade:", error);
            toast.error(t('toasts.quantityError'));
        }
    };

    // Função para atualizar configurações de estoque
    const handleUpdateConfiguracoes = async (novasConfiguracoes) => {
        try {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("[DEBUG] Enviando configurações:", novasConfiguracoes);
            const response = await updateConfiguracoesEstoque(novasConfiguracoes);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("[DEBUG] Resposta do servidor:", response.data);
            setConfiguracoesEstoque(novasConfiguracoes);
            toast.success(t('toasts.settingsUpdated'));
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao atualizar configurações:", error);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Status:", error.response?.status);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Data:", error.response?.data);
            toast.error(t('toasts.settingsError', { error: error.response?.data?.msg || error.message }));
        }
    };

    // Funções para controle de quantidade com setas
    const handleQuantidadeChange = (itemId, novaQuantidade) => {
        setQuantidadeTemp(prev => ({
            ...prev,
            [itemId]: Math.max(0, novaQuantidade)
        }));
        setShowConfirmQuantidade(prev => ({
            ...prev,
            [itemId]: true
        }));
    };

    const confirmarQuantidade = async (itemId) => {
        const quantidade = quantidadeTemp[itemId];
        if (quantidade !== undefined) {
            await updateQuantidadeEstoque(itemId, quantidade);
            setShowConfirmQuantidade(prev => ({
                ...prev,
                [itemId]: false
            }));
            setQuantidadeTemp(prev => {
                const newTemp = { ...prev };
                delete newTemp[itemId];
                return newTemp;
            });
        }
    };

    const cancelarQuantidade = (itemId) => {
        setShowConfirmQuantidade(prev => ({
            ...prev,
            [itemId]: false
        }));
        setQuantidadeTemp(prev => {
            const newTemp = { ...prev };
            delete newTemp[itemId];
            return newTemp;
        });
    };

    // Função para limpar filtros
    const limparFiltros = () => {
        setSearchMaterias("");
        setFiltroStatus("todos");
        setFiltroUnidade("todas");
    };

    // Funções para edição inline de quantidade de matérias-primas
    const handleClickQuantidadeMateria = (materiaId, quantidadeAtual) => {
        setEditingQuantidadeMateria(materiaId);
        setQuantidadeTempMateria({ [materiaId]: quantidadeAtual });
    };

    const handleQuantidadeMateriaChange = (materiaId, novaQuantidade) => {
        setQuantidadeTempMateria(prev => ({
            ...prev,
            [materiaId]: Math.max(0, novaQuantidade)
        }));
    };

    const handleQuantidadeMateriaKeyDown = (e, materiaId) => {
        if (e.key === 'Enter') {
            handleSaveQuantidadeMateria(materiaId);
        } else if (e.key === 'Escape') {
            setEditingQuantidadeMateria(null);
            setQuantidadeTempMateria({});
        }
    };

    const handleQuantidadeMateriaBlur = (materiaId) => {
        handleSaveQuantidadeMateria(materiaId);
    };

    const handleSaveQuantidadeMateria = async (materiaId) => {
        try {
            const novaQuantidade = quantidadeTempMateria[materiaId];
            if (novaQuantidade === undefined) return;

            const dadosParaAtualizar = { quantidade: novaQuantidade };

            await updateMateriaPrima(materiaId, dadosParaAtualizar);

            // Atualizar estado local
            setMateriasPrimas(prevMaterias =>
                prevMaterias.map(materia =>
                    materia._id === materiaId
                        ? { ...materia, quantidade: novaQuantidade }
                        : materia
                )
            );

            toast.success(t('toasts.materialQuantityUpdated'));
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao atualizar quantidade:", error);
            toast.error(t('toasts.materialQuantityError'));
        } finally {
            setEditingQuantidadeMateria(null);
            setQuantidadeTempMateria({});
        }
    };

    // Funções para matérias-primas
    const handleSaveMateriaPrima = async () => {
        try {
            // Preparar dados para envio, convertendo valores vazios
            const dadosParaEnvio = {
                ...formMateriaPrima,
                custoPorUnidade: formMateriaPrima.custoPorUnidade === '' ? null : parseFloat(formMateriaPrima.custoPorUnidade),
                quantidade: parseFloat(formMateriaPrima.quantidade) || 0,
                limiteMinimo: parseFloat(formMateriaPrima.limiteMinimo) || 0
            };



            let response;
            if (editingMateriaPrima) {
                response = await updateMateriaPrima(editingMateriaPrima._id, dadosParaEnvio);

                // Atualizar estado local imediatamente
                setMateriasPrimas(prevMaterias =>
                    prevMaterias.map(materia =>
                        materia._id === editingMateriaPrima._id
                            ? { ...materia, ...dadosParaEnvio }
                            : materia
                    )
                );

                toast.success(t('toasts.materialUpdated'));
            } else {
                response = await createMateriaPrima(dadosParaEnvio);

                // Adicionar nova matéria-prima ao estado local imediatamente
                if (response.data?.materiaPrima) {
                    setMateriasPrimas(prevMaterias => [...prevMaterias, response.data.materiaPrima]);
                }

                toast.success(t('toasts.materialCreated'));
            }

            // Fechar modal e limpar form
            setShowModalMateriaPrima(false);
            setEditingMateriaPrima(null);
            setFormMateriaPrima({
                nome: '',
                unidadeMedida: 'un',
                quantidade: 0,
                custoPorUnidade: '',
                limiteMinimo: 0
            });

            // Recarregar dados como backup
            setTimeout(() => {
                loadData();
            }, 1000);

        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao salvar matéria-prima:", error);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Status:", error.response?.status);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Data:", error.response?.data);
            toast.error(t('toasts.materialSaveError', { error: error.response?.data?.msg || error.message }));
        }
    };

    const handleEditMateriaPrima = (materiaPrima) => {
        setEditingMateriaPrima(materiaPrima);
        setFormMateriaPrima({
            nome: materiaPrima.nome,
            unidadeMedida: materiaPrima.unidadeMedida,
            quantidade: materiaPrima.quantidade,
            custoPorUnidade: materiaPrima.custoPorUnidade || '',
            limiteMinimo: materiaPrima.limiteMinimo
        });
        setShowModalMateriaPrima(true);
    };

    const handleDeleteMateriaPrima = (materiaPrima) => {
        setItemToDelete(materiaPrima);
        setShowConfirmDialog(true);
    };

    const confirmDelete = async () => {
        try {

            await deleteMateriaPrima(itemToDelete._id);

            // Remover do estado local imediatamente
            setMateriasPrimas(prevMaterias =>
                prevMaterias.filter(materia => materia._id !== itemToDelete._id)
            );

            toast.success(t('toasts.materialDeleted'));

            setShowConfirmDialog(false);
            setItemToDelete(null);

            // Recarregar dados como backup
            setTimeout(() => {
                loadData();
            }, 1000);
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao excluir matéria-prima:", error);
            toast.error(t('toasts.materialDeleteError'));
        }
    };

    // Itens com controle de estoque ativo (para dropdowns de movimentações)
    const itensComEstoque = useMemo(() =>
        Array.isArray(itens) ? itens.filter(item => item.controlarEstoque) : []
    , [itens]);

    // Filtrar itens e matérias-primas
    const itensFiltrados = Array.isArray(itens) ? itens.filter(item =>
        item.title?.toLowerCase().includes(searchItens.toLowerCase()) ||
        item.description?.toLowerCase().includes(searchItens.toLowerCase())
    ) : [];

    const materiasFiltradas = Array.isArray(materiasPrimas) ? materiasPrimas.filter(materia => {
        // Filtro por busca de texto
        const matchesSearch = materia.nome?.toLowerCase().includes(searchMaterias.toLowerCase());

        // Filtro por status
        let matchesStatus = true;
        if (filtroStatus === "disponivel") {
            matchesStatus = materia.quantidade > materia.limiteMinimo;
        } else if (filtroStatus === "estoque_baixo") {
            matchesStatus = materia.quantidade <= materia.limiteMinimo && materia.quantidade > 0;
        } else if (filtroStatus === "sem_estoque") {
            matchesStatus = materia.quantidade === 0;
        }

        // Filtro por unidade de medida
        const matchesUnidade = filtroUnidade === "todas" || materia.unidadeMedida === filtroUnidade;

        return matchesSearch && matchesStatus && matchesUnidade;
    }) : [];

    // Agrupar itens por categoria - garantir que são arrays válidos
    const itensAgrupados = Array.isArray(categorias) ? categorias.map(categoria => ({
        ...categoria,
        itens: itensFiltrados.filter(item => item.category_item_id === categoria._id)
    })).filter(categoria => categoria.itens.length > 0 || searchItens === "") : [];



    if (loading) {
        return (
            <PageContainer $sidebar={sidebar}>
                <ContentWrapper>
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh', width: '100%' }}>
                        <Loading type="spin" color="#007bff" height={50} width={50} />
                    </div>
                </ContentWrapper>
            </PageContainer>
        );
    }

    return (
        <>
            <PageContainer $sidebar={sidebar}>
                <ContentWrapper>
                    <div className="page-title-with-subtitle">
                        <div className="page-title-with-icon">
                            <div className="page-icon"><IoCubeOutline /></div>
                            <h1 className="page-title">{t('title')}</h1>
                        </div>
                        <p className="page-subtitle">{t('subtitle', 'Gerencie o estoque dos itens do seu cardapio')}</p>
                    </div>

                        <div className="gestao-estoque-content">
                            <Tabs
                                        activeKey={activeTab}
                                        onSelect={(k) => setActiveTab(k)}
                                        className="tabs-modern mb-4"
                                    >
                                        <Tab eventKey="itens" title={
                                            <span>
                                                <FaBoxOpen className="me-2" />
                                                {t('tabs.menuItems')}
                                            </span>
                                        }>
                                            <div className="row">
                                                <div className="col-12 mb-4">
                                                    <div className="search-container-modern">
                                                        <div className="search-icon-modern">
                                                            <FaSearch />
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="search-input-modern"
                                                            placeholder={t('search.itemsPlaceholder')}
                                                            value={searchItens}
                                                            onChange={(e) => setSearchItens(e.target.value)}
                                                        />
                                                        {searchItens && (
                                                            <button
                                                                className="search-clear-modern"
                                                                onClick={() => setSearchItens('')}
                                                                title={t('search.clearSearch')}
                                                            >
                                                                <FaTimes />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                                {!Array.isArray(itensAgrupados) ? (
                                                    <div className="col-12">
                                                        <p className="text-danger">{t('empty.errorNotArray')}</p>
                                                    </div>
                                                ) : itensAgrupados.length === 0 && searchItens ? (
                                                    <div className="col-12">
                                                        <p className="text-muted">{t('empty.noItemsForSearch', { search: searchItens })}</p>
                                                    </div>
                                                ) : itensAgrupados.length === 0 ? (
                                                    <div className="col-12">
                                                        <p className="text-muted">{t('empty.noCategories')}</p>
                                                    </div>
                                                ) : itensAgrupados.map((categoria) => (
                                                    <div key={categoria._id} className="col-12 mb-4">
                                                        <div className="categoria-card-modern">
                                                            <div className="categoria-header-modern">
                                                                <div className="categoria-title-modern">
                                                                    <FaBoxOpen className="categoria-icon-modern" />
                                                                    <h5 className="mb-0">{categoria.title}</h5>
                                                                </div>
                                                                <div className="categoria-badge-modern">
                                                                    {t('itemCount', { count: categoria.itens.length })}
                                                                </div>
                                                            </div>
                                                            <div className="card-body">
                                                                {categoria.itens.length === 0 ? (
                                                                    <p className="text-muted">{t('empty.noCategoryItems')}</p>
                                                                ) : (
                                                                    <div className="table-responsive-modern">
                                                                        <table className="table-modern">
                                                                            <thead className="table-header-modern">
                                                                                <tr>
                                                                                    <th className="th-modern">{t('table.item')}</th>
                                                                                    <th className="th-modern">{t('table.price')}</th>
                                                                                    <th className="th-modern">{t('table.controlStock')}</th>
                                                                                    <th className="th-modern">{t('table.quantity')}</th>
                                                                                    <th className="th-modern">{t('table.status')}</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody className="table-body-modern">
                                                                                {Array.isArray(categoria.itens) && categoria.itens.map((item) => (
                                                                                    <tr key={item._id} className="tr-modern">
                                                                                        <td className="td-modern">
                                                                                            <div className="item-info-modern">
                                                                                                <div className="item-title-modern">{item.title}</div>
                                                                                                {item.description && (
                                                                                                    <div className="item-description-modern">
                                                                                                        {item.description}
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className="td-modern">
                                                                                            <div className="price-modern">{formatPriceWithSymbol(item.price || 0)}</div>
                                                                                        </td>
                                                                                        <td className="td-modern">
                                                                                            <div
                                                                                                className={`toggle-modern ${item.controlarEstoque ? 'toggle-active' : 'toggle-inactive'}`}
                                                                                                onClick={() => toggleControleEstoque(item._id, item.controlarEstoque)}
                                                                                                title={item.controlarEstoque ? t('titles.disableStock') : t('titles.enableStock')}
                                                                                            ></div>
                                                                                        </td>
                                                                                        <td>
                                                                                            {item.controlarEstoque ? (
                                                                                                <div className="quantidade-controls-modern">
                                                                                                    <div className="quantidade-input-modern">
                                                                                                        <button
                                                                                                            className="btn-quantidade-modern btn-decrement"
                                                                                                            type="button"
                                                                                                            onClick={() => handleQuantidadeChange(item._id, (quantidadeTemp[item._id] ?? item.quantidadeEstoque ?? 0) - 1)}
                                                                                                            disabled={(quantidadeTemp[item._id] ?? item.quantidadeEstoque ?? 0) <= 0}
                                                                                                        >
                                                                                                            <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                                                                                                                <line x1={5} y1={12} x2={19} y2={12} />
                                                                                                            </svg>
                                                                                                        </button>
                                                                                                        <input
                                                                                                            type="number"
                                                                                                            className="input-quantidade-modern"
                                                                                                            value={quantidadeTemp[item._id] ?? item.quantidadeEstoque ?? 0}
                                                                                                            onChange={(e) => handleQuantidadeChange(item._id, parseInt(e.target.value) || 0)}
                                                                                                            min="0"
                                                                                                            placeholder="0"
                                                                                                        />
                                                                                                        <button
                                                                                                            className="btn-quantidade-modern btn-increment"
                                                                                                            type="button"
                                                                                                            onClick={() => handleQuantidadeChange(item._id, (quantidadeTemp[item._id] ?? item.quantidadeEstoque ?? 0) + 1)}
                                                                                                        >
                                                                                                            <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                                                                                                                <line x1={12} y1={5} x2={12} y2={19} />
                                                                                                                <line x1={5} y1={12} x2={19} y2={12} />
                                                                                                            </svg>
                                                                                                        </button>
                                                                                                    </div>
                                                                                                    {showConfirmQuantidade[item._id] && (
                                                                                                        <div className="confirm-buttons-modern">
                                                                                                            <button
                                                                                                                className="btn-confirm-modern btn-success-modern"
                                                                                                                onClick={() => confirmarQuantidade(item._id)}
                                                                                                                title={t('titles.confirmChange')}
                                                                                                            >
                                                                                                                <FaCheck size={14} />
                                                                                                            </button>
                                                                                                            <button
                                                                                                                className="btn-confirm-modern btn-cancel-modern"
                                                                                                                onClick={() => cancelarQuantidade(item._id)}
                                                                                                                title={t('titles.cancelChange')}
                                                                                                            >
                                                                                                                <FaTimes size={14} />
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            ) : (
                                                                                                <span className="text-muted-modern">-</span>
                                                                                            )}
                                                                                        </td>
                                                                                        <td className="td-modern">
                                                                                            {item.out ? (
                                                                                                <span className="status-badge-modern status-danger">
                                                                                                    <span className="status-dot"></span>
                                                                                                    {t('status.exhausted')}
                                                                                                </span>
                                                                                            ) : item.controlarEstoque && (item.quantidadeEstoque || 0) === 0 ? (
                                                                                                <span className="status-badge-modern status-warning">
                                                                                                    <span className="status-dot"></span>
                                                                                                    {t('status.outOfStock')}
                                                                                                </span>
                                                                                            ) : (
                                                                                                <span className="status-badge-modern status-success">
                                                                                                    <span className="status-dot"></span>
                                                                                                    {t('status.available')}
                                                                                                </span>
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </Tab>

                                        <Tab eventKey="materias" title={
                                            <span>
                                                <FaWarehouse className="me-2" />
                                                {t('tabs.rawMaterials')}
                                            </span>
                                        }>
                                            <div className="row">
                                                {/* Barra de Busca */}
                                                <div className="col-12 mb-3">
                                                    <div className="input-group search-input-group">
                                                        <span className="input-group-text">
                                                            <FaSearch />
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={t('search.materialsPlaceholder')}
                                                            value={searchMaterias}
                                                            onChange={(e) => setSearchMaterias(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Filtros e Botão Adicionar */}
                                                <div className="col-12 mb-3">
                                                    <div className="filtros-container">
                                                        <div className="row align-items-center">
                                                            <div className="col-md-8">
                                                                <div className="d-flex gap-3 align-items-center flex-wrap">
                                                                    <div className="d-flex align-items-center">
                                                                        <MdFilterList className="me-2 text-primary" size={20} />
                                                                        <span className="text-muted me-2 fw-semibold">{t('filters.label')}</span>
                                                                    </div>

                                                                    {/* Filtro por Status */}
                                                                    <select
                                                                        className="form-select form-select-sm"
                                                                        style={{ width: 'auto', minWidth: '190px' }}
                                                                        value={filtroStatus}
                                                                        onChange={(e) => setFiltroStatus(e.target.value)}
                                                                    >
                                                                        <option value="todos">{t('filters.status.all')}</option>
                                                                        <option value="disponivel">{t('filters.status.available')}</option>
                                                                        <option value="estoque_baixo">{t('filters.status.lowStock')}</option>
                                                                        <option value="sem_estoque">{t('filters.status.outOfStock')}</option>
                                                                    </select>

                                                                    {/* Filtro por Unidade */}
                                                                    <select
                                                                        className="form-select form-select-sm"
                                                                        style={{ width: 'auto', minWidth: '190px' }}
                                                                        value={filtroUnidade}
                                                                        onChange={(e) => setFiltroUnidade(e.target.value)}
                                                                    >
                                                                        <option value="todas">{t('filters.units.all')}</option>
                                                                        <option value="un">{t('filters.units.un')}</option>
                                                                        <option value="kg">{t('filters.units.kg')}</option>
                                                                        <option value="g">{t('filters.units.g')}</option>
                                                                        <option value="l">{t('filters.units.l')}</option>
                                                                        <option value="ml">{t('filters.units.ml')}</option>
                                                                    </select>

                                                                    {/* Contador de Resultados */}
                                                                    <span className="contador-resultados">
                                                                        {t('filters.resultsCount', { filtered: materiasFiltradas.length, total: materiasPrimas.length })}
                                                                    </span>

                                                                    {/* Botão Limpar Filtros */}
                                                                    {(searchMaterias || filtroStatus !== "todos" || filtroUnidade !== "todas") && (
                                                                        <button
                                                                            className="btn btn-outline-secondary btn-sm"
                                                                            onClick={limparFiltros}
                                                                            title={t('filters.clearAllTitle')}
                                                                        >
                                                                            <FaTimes className="me-1" size={12} />
                                                                            {t('filters.clearAll')}
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4 text-end">
                                                                <button
                                                                    className="btn btn-primary"
                                                                    onClick={() => {
                                                                        setEditingMateriaPrima(null);
                                                                        setFormMateriaPrima({
                                                                            nome: '',
                                                                            unidadeMedida: 'un',
                                                                            quantidade: 0,
                                                                            custoPorUnidade: '',
                                                                            limiteMinimo: 0
                                                                        });
                                                                        setShowModalMateriaPrima(true);
                                                                    }}
                                                                >
                                                                    <FaPlus className="me-2" />
                                                                    {t('buttons.addRawMaterial')}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            {materiasPrimas.length === 0 ? (
                                                                <div className="text-center py-4">
                                                                    <FaWarehouse size={48} className="text-muted mb-3" />
                                                                    <p className="text-muted">{t('empty.noMaterials')}</p>
                                                                    <button
                                                                        className="btn btn-outline-primary"
                                                                        onClick={() => {
                                                                            setEditingMateriaPrima(null);
                                                                            setFormMateriaPrima({
                                                                                nome: '',
                                                                                unidadeMedida: 'un',
                                                                                quantidade: 0,
                                                                                custoPorUnidade: '',
                                                                                limiteMinimo: 0
                                                                            });
                                                                            setShowModalMateriaPrima(true);
                                                                        }}
                                                                    >
                                                                        {t('buttons.registerFirst')}
                                                                    </button>
                                                                </div>
                                                            ) : materiasFiltradas.length === 0 ? (
                                                                <div className="text-center py-4">
                                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                                    <p className="text-muted">{t('empty.noMaterialsForSearch', { search: searchMaterias })}</p>
                                                                </div>
                                                            ) : (
                                                                <div className="table-responsive-modern">
                                                                    <table className="table-modern">
                                                                        <thead className="table-header-modern">
                                                                            <tr>
                                                                                <th className="th-modern">{t('table.rawMaterial')}</th>
                                                                                <th className="th-modern">{t('table.quantity')}</th>
                                                                                <th className="th-modern">{t('table.unit')}</th>
                                                                                <th className="th-modern">{t('table.costPerUnit')}</th>
                                                                                <th className="th-modern">{t('table.minLimit')}</th>
                                                                                <th className="th-modern">{t('table.status')}</th>
                                                                                <th className="th-modern">{t('table.actions')}</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody className="table-body-modern">
                                                                            {Array.isArray(materiasFiltradas) && materiasFiltradas.map((materiaPrima) => (
                                                                                <tr key={materiaPrima._id} className="tr-modern">
                                                                                    <td className="td-modern">
                                                                                        <div className="item-info-modern">
                                                                                            <div className="item-title-modern">{materiaPrima.nome}</div>
                                                                                            <div className="item-description-modern">
                                                                                                {t('description.rawMaterial')}
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="td-modern">
                                                                                        {editingQuantidadeMateria === materiaPrima._id ? (
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control form-control-sm"
                                                                                                style={{
                                                                                                    width: '80px',
                                                                                                    textAlign: 'center',
                                                                                                    border: '2px solid #4070f4',
                                                                                                    borderRadius: '6px'
                                                                                                }}
                                                                                                value={quantidadeTempMateria[materiaPrima._id] || 0}
                                                                                                onChange={(e) => handleQuantidadeMateriaChange(materiaPrima._id, parseInt(e.target.value) || 0)}
                                                                                                onKeyDown={(e) => handleQuantidadeMateriaKeyDown(e, materiaPrima._id)}
                                                                                                onBlur={() => handleQuantidadeMateriaBlur(materiaPrima._id)}
                                                                                                autoFocus
                                                                                                min="0"
                                                                                            />
                                                                                        ) : (
                                                                                            <div
                                                                                                className="price-modern d-flex align-items-center justify-content-between"
                                                                                                style={{ cursor: 'pointer', padding: '8px', borderRadius: '4px' }}
                                                                                                onClick={() => handleClickQuantidadeMateria(materiaPrima._id, materiaPrima.quantidade)}
                                                                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#d1d1d1'}
                                                                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                                                                title={t('titles.editQuantity')}
                                                                                            >
                                                                                                <span>{materiaPrima.quantidade}</span>
                                                                                                <FaEdit size={12} className="text-muted ms-2" />
                                                                                            </div>
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="td-modern">
                                                                                        <div className="d-flex justify-content-center align-items-center">
                                                                                            <span className="badge bg-secondary text-uppercase" style={{fontSize: '0.75rem', letterSpacing: '0.5px'}}>
                                                                                                {materiaPrima.unidadeMedida}
                                                                                            </span>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="td-modern">
                                                                                        <div className="price-modern">
                                                                                            {materiaPrima.custoPorUnidade
                                                                                                ? formatPriceWithSymbol(materiaPrima.custoPorUnidade)
                                                                                                : '-'
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="td-modern">
                                                                                        <span className="text-muted">{materiaPrima.limiteMinimo || '-'}</span>
                                                                                    </td>
                                                                                    <td className="td-modern">
                                                                                        {materiaPrima.quantidade === 0 ? (
                                                                                            <span className="status-badge-modern status-danger">
                                                                                                <span className="status-dot"></span>
                                                                                                {t('status.outOfStock')}
                                                                                            </span>
                                                                                        ) : materiaPrima.quantidade <= (materiaPrima.limiteMinimo || 0) ? (
                                                                                            <span className="status-badge-modern status-warning">
                                                                                                <span className="status-dot"></span>
                                                                                                {t('status.lowStock')}
                                                                                            </span>
                                                                                        ) : (
                                                                                            <span className="status-badge-modern status-success">
                                                                                                <span className="status-dot"></span>
                                                                                                {t('status.available')}
                                                                                            </span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="td-modern">
                                                                                        <div className="d-flex gap-2">
                                                                                            <button
                                                                                                className="btn btn-sm btn-outline-primary"
                                                                                                onClick={() => handleEditMateriaPrima(materiaPrima)}
                                                                                                title={t('titles.editRawMaterial')}
                                                                                            >
                                                                                                <FaEdit />
                                                                                            </button>
                                                                                            <button
                                                                                                className="btn btn-sm btn-outline-danger"
                                                                                                onClick={() => handleDeleteMateriaPrima(materiaPrima)}
                                                                                                title={t('titles.deleteRawMaterial')}
                                                                                            >
                                                                                                <FaTrash />
                                                                                            </button>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab>

                                        {/* ============ ABA RECEITAS ============ */}
                                        <Tab eventKey="receitas" title={
                                            <span>
                                                <IoNutrition className="me-2" />
                                                {t('tabs.recipes')}
                                            </span>
                                        }>
                                            <div className="row">
                                                <div className="col-12 mb-3">
                                                    <p className="text-muted">{t('recipes.subtitle')}</p>
                                                </div>
                                                <div className="col-12 mb-4">
                                                    <div className="search-container-modern">
                                                        <div className="search-icon-modern">
                                                            <FaSearch />
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="search-input-modern"
                                                            placeholder={t('search.recipesPlaceholder')}
                                                            value={searchReceitas}
                                                            onChange={(e) => setSearchReceitas(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                <Tabs activeKey={receitasSubTab} onSelect={setReceitasSubTab} className="mb-3">
                                                    {/* ---- SUB-ABA: ITENS DO CARDÁPIO ---- */}
                                                    <Tab eventKey="itens" title={t('recipes.subTabs.menuItems')}>
                                                <div>
                                                    {categorias.filter(c => !c.inativo).map(categoria => {
                                                        const catItens = itens.filter(i =>
                                                            i.category_item_id === categoria._id &&
                                                            !i.inativo &&
                                                            (!searchReceitas || i.title?.toLowerCase().includes(searchReceitas.toLowerCase()))
                                                        );
                                                        if (catItens.length === 0) return null;
                                                        return (
                                                            <div key={categoria._id} className="card mb-3">
                                                                <div className="card-header bg-light d-flex justify-content-between align-items-center">
                                                                    <strong>{categoria.title}</strong>
                                                                    <span className="badge bg-secondary">{catItens.length}</span>
                                                                </div>
                                                                <div className="card-body p-0">
                                                                    <table className="table table-hover mb-0">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>{t('table.item')}</th>
                                                                                <th>{t('table.price')}</th>
                                                                                <th>{t('recipes.hasRecipe', { count: 0 }).replace('0 ', '')}</th>
                                                                                <th>{t('table.actions')}</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {catItens.map(item => (
                                                                                <tr key={item._id}>
                                                                                    <td>{item.title}</td>
                                                                                    <td>{formatPriceWithSymbol(item.price)}</td>
                                                                                    <td>
                                                                                        {item.composicao && item.composicao.length > 0 ? (
                                                                                            <span className="badge bg-success">
                                                                                                {t('recipes.hasRecipe', { count: item.composicao.length })}
                                                                                            </span>
                                                                                        ) : (
                                                                                            <span className="badge bg-light text-muted">
                                                                                                {t('recipes.noRecipe')}
                                                                                            </span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td>
                                                                                        <button
                                                                                            className="btn btn-sm btn-outline-primary"
                                                                                            onClick={() => openRecipeModal('item', item._id, null, item.title, item.composicao)}
                                                                                        >
                                                                                            <MdReceipt className="me-1" />
                                                                                            {t('recipes.manageRecipe')}
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                    </Tab>

                                                    {/* ---- SUB-ABA: ADICIONAIS ---- */}
                                                    <Tab eventKey="adicionais" title={t('recipes.subTabs.additionals')}>
                                                <div>
                                                    {adicionaisGrupos.filter(g => !g.inativo).map(grupo => {
                                                        const filteredAdicionais = grupo.adicionais?.filter(a =>
                                                            !a.deletedAt &&
                                                            (!searchReceitas || a.title?.toLowerCase().includes(searchReceitas.toLowerCase()))
                                                        ) || [];
                                                        if (filteredAdicionais.length === 0) return null;
                                                        return (
                                                            <div key={grupo._id} className="card mb-3">
                                                                <div className="card-header bg-light d-flex justify-content-between align-items-center">
                                                                    <span>
                                                                        <strong>{grupo.title}</strong>
                                                                        {grupo.item_title && <small className="text-muted ms-2">({grupo.item_title})</small>}
                                                                        {grupo.type === 'pizza' && <span className="badge bg-warning text-dark ms-2">Pizza</span>}
                                                                    </span>
                                                                    <span className="badge bg-secondary">{filteredAdicionais.length}</span>
                                                                </div>
                                                                <div className="card-body p-0">
                                                                    <table className="table table-hover mb-0">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>{t('recipes.additionals')}</th>
                                                                                <th>{t('table.price')}</th>
                                                                                <th>{t('recipes.hasRecipe', { count: 0 }).replace('0 ', '')}</th>
                                                                                <th>{t('table.actions')}</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {filteredAdicionais.map(adicional => (
                                                                                <tr key={adicional.id_adicional}>
                                                                                    <td>{adicional.title}</td>
                                                                                    <td>{formatPriceWithSymbol(adicional.price)}</td>
                                                                                    <td>
                                                                                        {adicional.composicao && adicional.composicao.length > 0 ? (
                                                                                            <span className="badge bg-success">
                                                                                                {t('recipes.hasRecipe', { count: adicional.composicao.length })}
                                                                                            </span>
                                                                                        ) : (
                                                                                            <span className="badge bg-light text-muted">
                                                                                                {t('recipes.noRecipe')}
                                                                                            </span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td>
                                                                                        <button
                                                                                            className="btn btn-sm btn-outline-primary"
                                                                                            onClick={() => openRecipeModal('adicional', adicional.id_adicional, grupo._id, adicional.title, adicional.composicao)}
                                                                                        >
                                                                                            <MdReceipt className="me-1" />
                                                                                            {t('recipes.manageRecipe')}
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                    </Tab>
                                                </Tabs>
                                                </div>
                                            </div>
                                        </Tab>

                                        {/* ============ ABA MOVIMENTAÇÕES ============ */}
                                        <Tab eventKey="movimentacoes" title={
                                            <span>
                                                <FaExchangeAlt className="me-2" />
                                                {t('tabs.movements')}
                                            </span>
                                        }>
                                            <div className="mt-3">
                                                <Tabs activeKey={movSubTab} onSelect={setMovSubTab} className="mb-3">
                                                    {/* ---- SUB-ABA: ITENS DO CARDÁPIO ---- */}
                                                    <Tab eventKey="itens" title={t('movements.subTabs.menuItems')}>
                                                        <div className="row">
                                                            <div className="col-12 mb-3">
                                                                <div className="d-flex flex-wrap gap-2 align-items-end">
                                                                    <div>
                                                                        <label className="form-label small">{t('movements.movementType')}</label>
                                                                        <select className="form-select form-select-sm" value={filtroTipoMovItem} onChange={e => setFiltroTipoMovItem(e.target.value)}>
                                                                            <option value="">{t('movements.allTypes')}</option>
                                                                            <option value="entrada">{t('movements.type.entrada')}</option>
                                                                            <option value="saida_automatica">{t('movements.type.saida_automatica')}</option>
                                                                            <option value="ajuste">{t('movements.type.ajuste')}</option>
                                                                        </select>
                                                                    </div>
                                                                    <div>
                                                                        <label className="form-label small">{t('movements.item')}</label>
                                                                        <select className="form-select form-select-sm" value={filtroItemMov} onChange={e => setFiltroItemMov(e.target.value)}>
                                                                            <option value="">{t('movements.allItems')}</option>
                                                                            {itensComEstoque.map(item => (
                                                                                <option key={item._id} value={item._id}>{item.title}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div>
                                                                        <label className="form-label small">{t('movements.from')}</label>
                                                                        <input type="date" className="form-control form-control-sm" value={filtroDateStartItem} onChange={e => setFiltroDateStartItem(e.target.value)} />
                                                                    </div>
                                                                    <div>
                                                                        <label className="form-label small">{t('movements.to')}</label>
                                                                        <input type="date" className="form-control form-control-sm" value={filtroDateEndItem} onChange={e => setFiltroDateEndItem(e.target.value)} />
                                                                    </div>
                                                                    <div className="ms-auto d-flex gap-2">
                                                                        <button className="btn btn-sm btn-success" onClick={() => setShowItemEntryModal(true)}>
                                                                            <FaPlus className="me-1" />{t('movements.registerEntry')}
                                                                        </button>
                                                                        <button className="btn btn-sm btn-danger" onClick={() => setShowItemExitModal(true)}>
                                                                            <FaMinus className="me-1" />{t('movements.registerExit')}
                                                                        </button>
                                                                        <button className="btn btn-sm btn-warning" onClick={() => setShowItemAdjustmentModal(true)}>
                                                                            <FaEdit className="me-1" />{t('movements.registerAdjustment')}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12">
                                                                {movItensLoading ? (
                                                                    <div className="text-center py-4">
                                                                        <Loading type="spin" color="rgb(49, 140, 213)" height={40} width={40} />
                                                                    </div>
                                                                ) : movItens.length === 0 ? (
                                                                    <div className="text-center py-4 text-muted">{t('movements.noMovements')}</div>
                                                                ) : (
                                                                    <>
                                                                        <div className="table-responsive">
                                                                            <table className="table table-hover">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>{t('movements.dateTime')}</th>
                                                                                        <th>{t('movements.item')}</th>
                                                                                        <th>{t('movements.movementType')}</th>
                                                                                        <th>{t('movements.qty')}</th>
                                                                                        <th>{t('movements.previousQty')}</th>
                                                                                        <th>{t('movements.resultQty')}</th>
                                                                                        <th>{t('movements.reason')}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {movItens.map(mov => (
                                                                                        <tr key={mov._id}>
                                                                                            <td><small>{new Date(mov.createdAt).toLocaleString()}</small></td>
                                                                                            <td>{mov.itemId?.title || '-'}</td>
                                                                                            <td>
                                                                                                <span className="badge" style={{ backgroundColor: getMovementTypeColor(mov.tipo), color: '#fff' }}>
                                                                                                    {t(`movements.type.${mov.tipo}`)}
                                                                                                </span>
                                                                                            </td>
                                                                                            <td>{mov.quantidade}</td>
                                                                                            <td>{mov.quantidadeAnterior}</td>
                                                                                            <td><strong>{mov.quantidadeResultante}</strong></td>
                                                                                            <td><small>{mov.motivo}</small></td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        {movItensPagination.totalPages > 1 && (
                                                                            <div className="d-flex justify-content-center gap-2 mt-3">
                                                                                {Array.from({ length: movItensPagination.totalPages }, (_, i) => (
                                                                                    <button key={i} className={`btn btn-sm ${movItensPagination.page === i + 1 ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => loadMovimentacoesItens(i + 1)}>
                                                                                        {i + 1}
                                                                                    </button>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Tab>

                                                    {/* ---- SUB-ABA: MATÉRIAS-PRIMAS ---- */}
                                                    <Tab eventKey="materias_primas" title={t('movements.subTabs.rawMaterials')}>
                                                        <div className="row">
                                                            <div className="col-12 mb-3">
                                                                <div className="d-flex flex-wrap gap-2 align-items-end">
                                                                    <div>
                                                                        <label className="form-label small">{t('movements.movementType')}</label>
                                                                        <select className="form-select form-select-sm" value={filtroTipoMov} onChange={e => setFiltroTipoMov(e.target.value)}>
                                                                            <option value="">{t('movements.allTypes')}</option>
                                                                            <option value="entrada">{t('movements.type.entrada')}</option>
                                                                            <option value="saida">{t('movements.type.saida')}</option>
                                                                            <option value="saida_automatica">{t('movements.type.saida_automatica')}</option>
                                                                            <option value="ajuste">{t('movements.type.ajuste')}</option>
                                                                        </select>
                                                                    </div>
                                                                    <div>
                                                                        <label className="form-label small">{t('movements.rawMaterial')}</label>
                                                                        <select className="form-select form-select-sm" value={filtroMPMov} onChange={e => setFiltroMPMov(e.target.value)}>
                                                                            <option value="">{t('movements.allMaterials')}</option>
                                                                            {materiasPrimas.map(mp => (
                                                                                <option key={mp._id} value={mp._id}>{mp.nome}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div>
                                                                        <label className="form-label small">{t('movements.from')}</label>
                                                                        <input type="date" className="form-control form-control-sm" value={filtroDateStart} onChange={e => setFiltroDateStart(e.target.value)} />
                                                                    </div>
                                                                    <div>
                                                                        <label className="form-label small">{t('movements.to')}</label>
                                                                        <input type="date" className="form-control form-control-sm" value={filtroDateEnd} onChange={e => setFiltroDateEnd(e.target.value)} />
                                                                    </div>
                                                                    <div className="ms-auto d-flex gap-2">
                                                                        <button className="btn btn-sm btn-success" onClick={() => setShowEntryModal(true)}>
                                                                            <FaPlus className="me-1" />{t('movements.registerEntry')}
                                                                        </button>
                                                                        <button className="btn btn-sm btn-danger" onClick={() => setShowExitModal(true)}>
                                                                            <FaMinus className="me-1" />{t('movements.registerExit')}
                                                                        </button>
                                                                        <button className="btn btn-sm btn-warning" onClick={() => setShowAdjustmentModal(true)}>
                                                                            <FaEdit className="me-1" />{t('movements.registerAdjustment')}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12">
                                                                {movimentacoesLoading ? (
                                                                    <div className="text-center py-4">
                                                                        <Loading type="spin" color="rgb(49, 140, 213)" height={40} width={40} />
                                                                    </div>
                                                                ) : movimentacoes.length === 0 ? (
                                                                    <div className="text-center py-4 text-muted">{t('movements.noMovements')}</div>
                                                                ) : (
                                                                    <>
                                                                        <div className="table-responsive">
                                                                            <table className="table table-hover">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>{t('movements.dateTime')}</th>
                                                                                        <th>{t('movements.rawMaterial')}</th>
                                                                                        <th>{t('movements.movementType')}</th>
                                                                                        <th>{t('movements.origin')}</th>
                                                                                        <th>{t('movements.qty')}</th>
                                                                                        <th>{t('movements.previousQty')}</th>
                                                                                        <th>{t('movements.resultQty')}</th>
                                                                                        <th>{t('movements.reason')}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {movimentacoes.map(mov => (
                                                                                        <tr key={mov._id}>
                                                                                            <td><small>{new Date(mov.createdAt).toLocaleString()}</small></td>
                                                                                            <td>{mov.materiaPrimaId?.nome || '-'}</td>
                                                                                            <td>
                                                                                                <span className="badge" style={{ backgroundColor: getMovementTypeColor(mov.tipo), color: '#fff' }}>
                                                                                                    {t(`movements.type.${mov.tipo}`)}
                                                                                                </span>
                                                                                            </td>
                                                                                            <td>
                                                                                                <span className="badge" style={{ backgroundColor: mov.origem === 'adicional' ? '#667eea' : '#6c757d', color: '#fff' }}>
                                                                                                    {mov.origem === 'adicional' ? t('movements.originAdditional') : t('movements.originRecipe')}
                                                                                                </span>
                                                                                            </td>
                                                                                            <td>{mov.quantidade}</td>
                                                                                            <td>{mov.quantidadeAnterior}</td>
                                                                                            <td><strong>{mov.quantidadeResultante}</strong></td>
                                                                                            <td><small>{mov.motivo}</small></td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        {movimentacoesPagination.totalPages > 1 && (
                                                                            <div className="d-flex justify-content-center gap-2 mt-3">
                                                                                {Array.from({ length: movimentacoesPagination.totalPages }, (_, i) => (
                                                                                    <button key={i} className={`btn btn-sm ${movimentacoesPagination.page === i + 1 ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => loadMovimentacoes(i + 1)}>
                                                                                        {i + 1}
                                                                                    </button>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                </Tabs>
                                            </div>
                                        </Tab>

                                        <Tab eventKey="configuracoes" title={
                                            <span>
                                                <FaCog className="me-2" />
                                                {t('tabs.settings')}
                                            </span>
                                        }>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="card">
                                                        <div className="card-header bg-light">
                                                            <h5 className="mb-0">{t('settings.sectionTitle')}</h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-md-4 mb-3">
                                                                    <div className="form-check form-switch">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id="habilitarEstoque"
                                                                            checked={configuracoesEstoque.habilitado}
                                                                            onChange={(e) => {
                                                                                const novasConfiguracoes = {
                                                                                    ...configuracoesEstoque,
                                                                                    habilitado: e.target.checked
                                                                                };
                                                                                handleUpdateConfiguracoes(novasConfiguracoes);
                                                                            }}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="habilitarEstoque">
                                                                            <strong>{t('settings.enableModule')}</strong>
                                                                        </label>
                                                                        <small className="form-text text-muted d-block">
                                                                            {t('settings.enableModuleHelp')}
                                                                        </small>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-4 mb-3">
                                                                    <div className="form-check form-switch">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id="baixaAutomatica"
                                                                            checked={configuracoesEstoque.darBaixaAutomatica}
                                                                            onChange={(e) => {
                                                                                const novasConfiguracoes = {
                                                                                    ...configuracoesEstoque,
                                                                                    darBaixaAutomatica: e.target.checked
                                                                                };
                                                                                handleUpdateConfiguracoes(novasConfiguracoes);
                                                                            }}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="baixaAutomatica">
                                                                            <strong>{t('settings.autoLowering')}</strong>
                                                                        </label>
                                                                        <small className="form-text text-muted d-block">
                                                                            {t('settings.autoLoweringHelp')}
                                                                        </small>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-4 mb-3">
                                                                    <div className="form-check form-switch">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id="esgotarAutomatico"
                                                                            checked={configuracoesEstoque.esgotarItemAutomaticamente}
                                                                            onChange={(e) => {
                                                                                const novasConfiguracoes = {
                                                                                    ...configuracoesEstoque,
                                                                                    esgotarItemAutomaticamente: e.target.checked
                                                                                };
                                                                                handleUpdateConfiguracoes(novasConfiguracoes);
                                                                            }}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="esgotarAutomatico">
                                                                            <strong>{t('settings.autoExhaustion')}</strong>
                                                                        </label>
                                                                        <small className="form-text text-muted d-block">
                                                                            {t('settings.autoExhaustionHelp')}
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <hr />

                                                            <div className="row">
                                                                <div className="col-md-4 mb-3">
                                                                    <div className="form-check form-switch">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id="decrementarMP"
                                                                            checked={configuracoesEstoque.decrementarMateriaPrima !== false}
                                                                            onChange={(e) => {
                                                                                handleUpdateConfiguracoes({
                                                                                    ...configuracoesEstoque,
                                                                                    decrementarMateriaPrima: e.target.checked
                                                                                });
                                                                            }}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="decrementarMP">
                                                                            <strong>{t('settings.decrementMaterials')}</strong>
                                                                        </label>
                                                                        <small className="form-text text-muted d-block">
                                                                            {t('settings.decrementMaterialsHelp')}
                                                                        </small>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-4 mb-3">
                                                                    <div className="form-check form-switch">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id="bloquearSemEstoque"
                                                                            checked={configuracoesEstoque.bloquearPedidoSemEstoque === true}
                                                                            onChange={(e) => {
                                                                                handleUpdateConfiguracoes({
                                                                                    ...configuracoesEstoque,
                                                                                    bloquearPedidoSemEstoque: e.target.checked
                                                                                });
                                                                            }}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="bloquearSemEstoque">
                                                                            <strong>{t('settings.blockNoStock')}</strong>
                                                                        </label>
                                                                        <small className="form-text text-muted d-block">
                                                                            {t('settings.blockNoStockHelp')}
                                                                        </small>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-4 mb-3">
                                                                    <div className="form-check form-switch">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id="alertaEstoqueBaixo"
                                                                            checked={configuracoesEstoque.alertaEstoqueBaixo !== false}
                                                                            onChange={(e) => {
                                                                                handleUpdateConfiguracoes({
                                                                                    ...configuracoesEstoque,
                                                                                    alertaEstoqueBaixo: e.target.checked
                                                                                });
                                                                            }}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="alertaEstoqueBaixo">
                                                                            <strong>{t('settings.lowStockAlert')}</strong>
                                                                        </label>
                                                                        <small className="form-text text-muted d-block">
                                                                            {t('settings.lowStockAlertHelp')}
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <hr />

                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <h6 className="text-muted">{t('settings.infoTitle')}</h6>
                                                                    <ul className="list-unstyled">
                                                                        <li><small><strong>{t('settings.moduleLabel')}</strong> {configuracoesEstoque.habilitado ? t('settings.enabled') : t('settings.disabled')}</small></li>
                                                                        <li><small><strong>{t('settings.loweringLabel')}</strong> {configuracoesEstoque.darBaixaAutomatica ? t('settings.active') : t('settings.inactive')}</small></li>
                                                                        <li><small><strong>{t('settings.exhaustionLabel')}</strong> {configuracoesEstoque.esgotarItemAutomaticamente ? t('settings.activeM') : t('settings.inactiveM')}</small></li>
                                                                        <li><small><strong>{t('settings.materialsLabel')}</strong> {configuracoesEstoque.decrementarMateriaPrima !== false ? t('settings.activeM') : t('settings.inactiveM')}</small></li>
                                                                        <li><small><strong>{t('settings.blockLabel')}</strong> {configuracoesEstoque.bloquearPedidoSemEstoque ? t('settings.activeM') : t('settings.inactiveM')}</small></li>
                                                                        <li><small><strong>{t('settings.alertLabel')}</strong> {configuracoesEstoque.alertaEstoqueBaixo !== false ? t('settings.activeM') : t('settings.inactiveM')}</small></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab>
                            </Tabs>
                        </div>
                </ContentWrapper>
            </PageContainer>

            {/* Modal para Matéria-Prima */}
            <Modal
                show={showModalMateriaPrima}
                onHide={() => setShowModalMateriaPrima(false)}
                size="lg"
                centered
                className="modal-materia-prima-modern"
            >
                <Modal.Header closeButton className="modal-header-modern">
                    <Modal.Title className="modal-title-modern">
                        <FaWarehouse className="modal-icon-modern" />
                        {editingMateriaPrima ? t('modal.titleEdit') : t('modal.titleNew')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-body-modern">
                    <form className="form-modern">
                        <div className="form-section-modern">
                            <h6 className="form-section-title-modern">{t('modal.basicInfo')}</h6>
                            <div className="row">
                                <div className="col-lg-7 col-md-6 mb-3">
                                    <label className="form-label-modern">{t('modal.name')}</label>
                                    <div className="input-container-modern">
                                        <input
                                            type="text"
                                            className="form-control-modern"
                                            value={formMateriaPrima.nome}
                                            onChange={(e) => setFormMateriaPrima({
                                                ...formMateriaPrima,
                                                nome: e.target.value
                                            })}
                                            placeholder={t('modal.namePlaceholder')}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-6 mb-3">
                                    <label className="form-label-modern text-nowrap">{t('modal.unitOfMeasure')}</label>
                                    <div className="select-container-modern">
                                        <select
                                            className="form-select-modern"
                                            value={formMateriaPrima.unidadeMedida}
                                            onChange={(e) => setFormMateriaPrima({
                                                ...formMateriaPrima,
                                                unidadeMedida: e.target.value
                                            })}
                                        >
                                            <option value="un">{t('modal.unitOptions.un')}</option>
                                            <option value="kg">{t('modal.unitOptions.kg')}</option>
                                            <option value="g">{t('modal.unitOptions.g')}</option>
                                            <option value="l">{t('modal.unitOptions.l')}</option>
                                            <option value="ml">{t('modal.unitOptions.ml')}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-section-modern">
                            <h6 className="form-section-title-modern">{t('modal.stockControl')}</h6>
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label className="form-label-modern">{t('modal.currentQuantity')}</label>
                                    <div className="input-container-modern">
                                        <input
                                            type="number"
                                            className="form-control-modern"
                                            min="0"
                                            step="0.01"
                                            value={formMateriaPrima.quantidade}
                                            onChange={(e) => setFormMateriaPrima({
                                                ...formMateriaPrima,
                                                quantidade: e.target.value === '' ? '' : parseFloat(e.target.value) || 0
                                            })}
                                            placeholder={t('modal.quantityPlaceholder')}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="form-label-modern">{t('modal.costPerUnit')}</label>
                                    <div className="input-container-modern">
                                        <span className="input-prefix-modern">{getCurrencySymbol()}</span>
                                        <input
                                            type="number"
                                            className="form-control-modern with-prefix"
                                            min="0"
                                            step="0.01"
                                            value={formMateriaPrima.custoPorUnidade}
                                            onChange={(e) => setFormMateriaPrima({
                                                ...formMateriaPrima,
                                                custoPorUnidade: e.target.value
                                            })}
                                            placeholder={t('modal.costPlaceholder')}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="form-label-modern">{t('modal.minLimit')}</label>
                                    <div className="input-container-modern">
                                        <input
                                            type="number"
                                            className="form-control-modern"
                                            min="0"
                                            step="0.01"
                                            value={formMateriaPrima.limiteMinimo}
                                            onChange={(e) => setFormMateriaPrima({
                                                ...formMateriaPrima,
                                                limiteMinimo: e.target.value === '' ? '' : parseFloat(e.target.value) || 0
                                            })}
                                            placeholder={t('modal.quantityPlaceholder')}
                                        />
                                    </div>
                                    <small className="form-help-text-modern">
                                        {t('modal.minLimitHelp')}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer className="modal-footer-modern">
                    <button
                        type="button"
                        className="btn-modal-modern btn-cancel-modern"
                        onClick={() => setShowModalMateriaPrima(false)}
                    >
                        <FaTimes className="btn-icon-modern" />
                        {t('modal.cancel')}
                    </button>
                    <button
                        type="button"
                        className="btn-modal-modern btn-primary-modern"
                        onClick={handleSaveMateriaPrima}
                        disabled={!formMateriaPrima.nome.trim()}
                    >
                        <FaCheck className="btn-icon-modern" />
                        {editingMateriaPrima ? t('modal.update') : t('modal.save')}
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Dialog de Confirmação */}
            <ConfirmDialog
                open={showConfirmDialog}
                setOpen={setShowConfirmDialog}
                title={t('confirmDelete.title')}
                onConfirm={confirmDelete}
            >
                <p>{t('confirmDelete.message')} <strong>"{itemToDelete?.nome}"</strong>?</p>
                <p className="text-muted">{t('confirmDelete.warning')}</p>
            </ConfirmDialog>

            {/* Modal de Receita */}
            <Modal
                show={showRecipeModal}
                onHide={() => setShowRecipeModal(false)}
                size="lg"
                centered
                className="modal-estoque-centered"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <IoNutrition className="me-2" />
                        {t('recipes.modalTitle', { name: recipeTarget?.name || '' })}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {recipeIngredients.length === 0 ? (
                        <p className="text-muted text-center py-3">{t('recipes.noRecipe')}</p>
                    ) : (
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>{t('recipes.ingredient')}</th>
                                        <th>{t('recipes.unitLabel')}</th>
                                        <th>{t('recipes.quantityUsed')}</th>
                                        <th style={{ width: 60 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {recipeIngredients.map((ing, index) => (
                                        <tr key={index}>
                                            <td>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={ing.materiaPrimaId || ''}
                                                    onChange={(e) => updateRecipeIngredient(index, 'materiaPrimaId', e.target.value)}
                                                >
                                                    <option value="">{t('recipes.selectMaterial')}</option>
                                                    {materiasPrimas.map(mp => (
                                                        <option key={mp._id} value={mp._id}>{mp.nome}</option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td>
                                                <small className="text-muted">{ing._mpData?.unidadeMedida || '-'}</small>
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    min="0"
                                                    step="0.01"
                                                    value={ing.quantidadeUtilizada}
                                                    onChange={(e) => updateRecipeIngredient(index, 'quantidadeUtilizada', e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => removeRecipeIngredient(index)}
                                                    title={t('recipes.remove')}
                                                >
                                                    <FaTrash />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <button className="btn btn-sm btn-outline-primary" onClick={addRecipeIngredient}>
                        <FaPlus className="me-1" />{t('recipes.addIngredient')}
                    </button>

                    {recipeIngredients.some(i => i._mpData?.custoPorUnidade) && (
                        <div className="mt-3 p-2 bg-light rounded">
                            <strong>{t('recipes.estimatedCost')}:</strong>{' '}
                            {formatPriceWithSymbol(getRecipeCost())}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowRecipeModal(false)}>
                        <FaTimes className="me-1" />{t('modal.cancel')}
                    </button>
                    <button className="btn btn-primary" onClick={saveRecipe} disabled={savingRecipe}>
                        <FaCheck className="me-1" />{savingRecipe ? '...' : t('modal.save')}
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Entrada de Estoque */}
            <Modal show={showEntryModal} onHide={() => setShowEntryModal(false)} centered className="modal-estoque-centered">
                <Modal.Header closeButton>
                    <Modal.Title>{t('movements.entryModal.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.entryModal.material')}</label>
                        <select
                            className="form-select"
                            value={entryForm.materiaPrimaId}
                            onChange={(e) => setEntryForm({ ...entryForm, materiaPrimaId: e.target.value })}
                        >
                            <option value="">{t('recipes.selectMaterial')}</option>
                            {materiasPrimas.map(mp => (
                                <option key={mp._id} value={mp._id}>{mp.nome} ({mp.quantidade} {mp.unidadeMedida})</option>
                            ))}
                        </select>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.entryModal.quantity')}</label>
                        <input
                            type="number"
                            className="form-control"
                            min="0.01"
                            step="0.01"
                            value={entryForm.quantidade}
                            onChange={(e) => setEntryForm({ ...entryForm, quantidade: e.target.value })}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.entryModal.reason')}</label>
                        <input
                            type="text"
                            className="form-control"
                            value={entryForm.motivo}
                            onChange={(e) => setEntryForm({ ...entryForm, motivo: e.target.value })}
                            placeholder={t('movements.entryModal.reasonPlaceholder')}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowEntryModal(false)}>{t('modal.cancel')}</button>
                    <button className="btn btn-success" onClick={handleSaveEntry}>{t('modal.save')}</button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Ajuste de Estoque */}
            <Modal show={showAdjustmentModal} onHide={() => setShowAdjustmentModal(false)} centered className="modal-estoque-centered">
                <Modal.Header closeButton>
                    <Modal.Title>{t('movements.adjustmentModal.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.adjustmentModal.material')}</label>
                        <select
                            className="form-select"
                            value={adjustmentForm.materiaPrimaId}
                            onChange={(e) => {
                                const mp = materiasPrimas.find(m => m._id === e.target.value);
                                setAdjustmentForm({ ...adjustmentForm, materiaPrimaId: e.target.value, _currentQty: mp?.quantidade || 0 });
                            }}
                        >
                            <option value="">{t('recipes.selectMaterial')}</option>
                            {materiasPrimas.map(mp => (
                                <option key={mp._id} value={mp._id}>{mp.nome} ({mp.quantidade} {mp.unidadeMedida})</option>
                            ))}
                        </select>
                    </div>
                    {adjustmentForm.materiaPrimaId && (
                        <div className="mb-3">
                            <label className="form-label">{t('movements.adjustmentModal.currentQty')}</label>
                            <input type="text" className="form-control" disabled value={adjustmentForm._currentQty || 0} />
                        </div>
                    )}
                    <div className="mb-3">
                        <label className="form-label">{t('movements.adjustmentModal.newQty')}</label>
                        <input
                            type="number"
                            className="form-control"
                            min="0"
                            step="0.01"
                            value={adjustmentForm.novaQuantidade}
                            onChange={(e) => setAdjustmentForm({ ...adjustmentForm, novaQuantidade: e.target.value })}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.adjustmentModal.reason')}</label>
                        <input
                            type="text"
                            className="form-control"
                            value={adjustmentForm.motivo}
                            onChange={(e) => setAdjustmentForm({ ...adjustmentForm, motivo: e.target.value })}
                            placeholder={t('movements.adjustmentModal.reasonPlaceholder')}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowAdjustmentModal(false)}>{t('modal.cancel')}</button>
                    <button className="btn btn-warning" onClick={handleSaveAdjustment}>{t('modal.save')}</button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Entrada de Estoque - ITEM */}
            <Modal show={showItemEntryModal} onHide={() => setShowItemEntryModal(false)} centered className="modal-estoque-centered">
                <Modal.Header closeButton>
                    <Modal.Title>{t('movements.itemEntryModal.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.itemEntryModal.item')}</label>
                        <select
                            className="form-select"
                            value={itemEntryForm.itemId}
                            onChange={(e) => setItemEntryForm({ ...itemEntryForm, itemId: e.target.value })}
                        >
                            <option value="">{t('movements.selectItem')}</option>
                            {itensComEstoque.map(item => (
                                <option key={item._id} value={item._id}>{item.title} ({item.quantidadeEstoque || 0} un)</option>
                            ))}
                        </select>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.itemEntryModal.quantity')}</label>
                        <input
                            type="number"
                            className="form-control"
                            min="0.01"
                            step="0.01"
                            value={itemEntryForm.quantidade}
                            onChange={(e) => setItemEntryForm({ ...itemEntryForm, quantidade: e.target.value })}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.itemEntryModal.reason')}</label>
                        <input
                            type="text"
                            className="form-control"
                            value={itemEntryForm.motivo}
                            onChange={(e) => setItemEntryForm({ ...itemEntryForm, motivo: e.target.value })}
                            placeholder={t('movements.itemEntryModal.reasonPlaceholder')}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowItemEntryModal(false)}>{t('modal.cancel')}</button>
                    <button className="btn btn-success" onClick={handleSaveItemEntry}>{t('modal.save')}</button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Ajuste de Estoque - ITEM */}
            <Modal show={showItemAdjustmentModal} onHide={() => setShowItemAdjustmentModal(false)} centered className="modal-estoque-centered">
                <Modal.Header closeButton>
                    <Modal.Title>{t('movements.itemAdjustmentModal.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.itemAdjustmentModal.item')}</label>
                        <select
                            className="form-select"
                            value={itemAdjustmentForm.itemId}
                            onChange={(e) => {
                                const item = itensComEstoque.find(i => i._id === e.target.value);
                                setItemAdjustmentForm({ ...itemAdjustmentForm, itemId: e.target.value, _currentQty: item?.quantidadeEstoque || 0 });
                            }}
                        >
                            <option value="">{t('movements.selectItem')}</option>
                            {itensComEstoque.map(item => (
                                <option key={item._id} value={item._id}>{item.title} ({item.quantidadeEstoque || 0} un)</option>
                            ))}
                        </select>
                    </div>
                    {itemAdjustmentForm.itemId && (
                        <div className="mb-3">
                            <label className="form-label">{t('movements.itemAdjustmentModal.currentQty')}</label>
                            <input type="text" className="form-control" disabled value={itemAdjustmentForm._currentQty || 0} />
                        </div>
                    )}
                    <div className="mb-3">
                        <label className="form-label">{t('movements.itemAdjustmentModal.newQty')}</label>
                        <input
                            type="number"
                            className="form-control"
                            min="0"
                            step="0.01"
                            value={itemAdjustmentForm.novaQuantidade}
                            onChange={(e) => setItemAdjustmentForm({ ...itemAdjustmentForm, novaQuantidade: e.target.value })}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.itemAdjustmentModal.reason')}</label>
                        <input
                            type="text"
                            className="form-control"
                            value={itemAdjustmentForm.motivo}
                            onChange={(e) => setItemAdjustmentForm({ ...itemAdjustmentForm, motivo: e.target.value })}
                            placeholder={t('movements.itemAdjustmentModal.reasonPlaceholder')}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowItemAdjustmentModal(false)}>{t('modal.cancel')}</button>
                    <button className="btn btn-warning" onClick={handleSaveItemAdjustment}>{t('modal.save')}</button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Saída de Estoque - MP */}
            <Modal show={showExitModal} onHide={() => setShowExitModal(false)} centered className="modal-estoque-centered">
                <Modal.Header closeButton>
                    <Modal.Title>{t('movements.exitModal.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.exitModal.material')}</label>
                        <select
                            className="form-select"
                            value={exitForm.materiaPrimaId}
                            onChange={(e) => setExitForm({ ...exitForm, materiaPrimaId: e.target.value })}
                        >
                            <option value="">{t('recipes.selectMaterial')}</option>
                            {materiasPrimas.map(mp => (
                                <option key={mp._id} value={mp._id}>{mp.nome} ({mp.quantidade} {mp.unidadeMedida})</option>
                            ))}
                        </select>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.exitModal.quantity')}</label>
                        <input type="number" className="form-control" min="0.01" step="0.01" value={exitForm.quantidade} onChange={(e) => setExitForm({ ...exitForm, quantidade: e.target.value })} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.exitModal.reason')}</label>
                        <input type="text" className="form-control" value={exitForm.motivo} onChange={(e) => setExitForm({ ...exitForm, motivo: e.target.value })} placeholder={t('movements.exitModal.reasonPlaceholder')} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowExitModal(false)}>{t('modal.cancel')}</button>
                    <button className="btn btn-danger" onClick={handleSaveExit}>{t('modal.save')}</button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Saída de Estoque - ITEM */}
            <Modal show={showItemExitModal} onHide={() => setShowItemExitModal(false)} centered className="modal-estoque-centered">
                <Modal.Header closeButton>
                    <Modal.Title>{t('movements.itemExitModal.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.itemExitModal.item')}</label>
                        <select
                            className="form-select"
                            value={itemExitForm.itemId}
                            onChange={(e) => setItemExitForm({ ...itemExitForm, itemId: e.target.value })}
                        >
                            <option value="">{t('movements.selectItem')}</option>
                            {itensComEstoque.map(item => (
                                <option key={item._id} value={item._id}>{item.title} ({item.quantidadeEstoque || 0} un)</option>
                            ))}
                        </select>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.itemExitModal.quantity')}</label>
                        <input type="number" className="form-control" min="0.01" step="0.01" value={itemExitForm.quantidade} onChange={(e) => setItemExitForm({ ...itemExitForm, quantidade: e.target.value })} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">{t('movements.itemExitModal.reason')}</label>
                        <input type="text" className="form-control" value={itemExitForm.motivo} onChange={(e) => setItemExitForm({ ...itemExitForm, motivo: e.target.value })} placeholder={t('movements.itemExitModal.reasonPlaceholder')} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowItemExitModal(false)}>{t('modal.cancel')}</button>
                    <button className="btn btn-danger" onClick={handleSaveItemExit}>{t('modal.save')}</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default GestaoEstoque;
